/* Passion for Jerseys — carousels, hero slider, countdown (new file) */
(function(){
  function initCarousel(root){
    if(root.dataset.p4jReady) return; root.dataset.p4jReady='1';
    var track=root.querySelector('.p4j-track'); if(!track) return;
    var prev=root.querySelector('[data-p4j-prev]'), next=root.querySelector('[data-p4j-next]'), bar=root.querySelector('.p4j-prog i');
    function step(){var c=track.children[0];return c?(c.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||5))*Math.max(1,Math.floor(track.clientWidth/(c.getBoundingClientRect().width||1))-1):track.clientWidth*.8}
    function upd(){
      var max=track.scrollWidth-track.clientWidth, x=track.scrollLeft;
      if(prev) prev.disabled=x<=2; if(next) next.disabled=x>=max-2;
      if(bar){var w=Math.max(12,Math.min(100,track.clientWidth/track.scrollWidth*100));bar.style.width=w+'%';bar.style.left=(max>0?x/max*(100-w):0)+'%';}
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
    track.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
  }
  function initHero(root){
    if(root.dataset.p4jReady) return; root.dataset.p4jReady='1';
    var s=[].slice.call(root.querySelectorAll('.p4j-hero__s')), d=[].slice.call(root.querySelectorAll('.p4j-hero__dots button'));
    if(s.length<2) return; var i=0, t, ms=(+root.dataset.speed||5)*1000;
    function go(n){s[i].classList.remove('is-on'); d[i]&&d[i].classList.remove('is-on'); i=(n+s.length)%s.length; s[i].classList.add('is-on'); d[i]&&d[i].classList.add('is-on');}
    function play(){clearInterval(t); t=setInterval(function(){go(i+1)},ms);}
    d.forEach(function(b,n){b.addEventListener('click',function(){go(n);play();})});
    var x0=null; root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    root.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){go(i+(dx<0?1:-1));play();}x0=null});
    play();
  }
  function initTimer(root){
    if(root.dataset.p4jReady) return; root.dataset.p4jReady='1';
    var h=root.querySelector('[data-h]'),m=root.querySelector('[data-m]'),s=root.querySelector('[data-s]');
    function tick(){
      var now=new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'}));
      var end=new Date(now); end.setHours(24,0,0,0); if(root.dataset.end){var e2=new Date(root.dataset.end); if(!isNaN(e2) && e2>now) end=e2;} var r=Math.max(0,Math.floor((end-now)/1000));
      var p=function(n){return (n<10?'0':'')+n}; h.textContent=p(Math.floor(r/3600)); m.textContent=p(Math.floor(r%3600/60)); s.textContent=p(r%60);
    }
    tick(); setInterval(tick,1000);
  }
  function boot(){
    document.querySelectorAll('[data-p4j-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-p4j-hero]').forEach(initHero);
    document.querySelectorAll('[data-p4j-timer]').forEach(initTimer);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
